import { render, staticRenderFns } from "./HowItWorksWidget.vue?vue&type=template&id=454a3d8e"
import script from "./HowItWorksWidget.vue?vue&type=script&lang=js"
export * from "./HowItWorksWidget.vue?vue&type=script&lang=js"
import style0 from "./HowItWorksWidget.vue?vue&type=style&index=0&id=454a3d8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports